var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"badge-contianer"},[_vm._t("default"),_c('div',{staticClass:"badge-label"},[_vm._v(_vm._s(_vm.label))])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }